import * as React from "react";
const SvgBatteryHorizontal0PercentCharging20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 12,
        fill: "black",
        viewBox: "0 0 20 12"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M0 0h18v3h2v6h-2v3H0V0Zm2 2v8h6.083L9 7.25H4L9.25 2H2Zm14 8H8.75L14 4.75H9L9.917 2H16v8Z",
      clipRule: "evenodd"
    })
  );
export default SvgBatteryHorizontal0PercentCharging20Px;
